<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import TabBar from 'dashboard/components-next/tabbar/TabBar.vue';

const TABS = [
  { labelKey: 'CLIENT_SETTINGS.TABS.FEATURES', route: 'client_settings_index' },
  {
    labelKey: 'CLIENT_SETTINGS.TABS.CURRENCY_MIGRATION',
    route: 'client_settings_currency_migrations',
  },
];

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const tabs = computed(() =>
  TABS.map(tab => ({ label: t(tab.labelKey), name: tab.route }))
);

const activeTab = computed(() => {
  const index = TABS.findIndex(tab => tab.route === route.name);
  return index === -1 ? 0 : index;
});

const onTabChanged = tab => {
  if (tab.name === route.name) return;
  router.push({ name: tab.name, params: { accountId: route.params.accountId } });
};
</script>

<template>
  <TabBar
    :tabs="tabs"
    :initial-active-tab="activeTab"
    data-testid="client-settings-tabs"
    @tab-changed="onTabChanged"
  />
</template>
